module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[63]550.e4ba889.woff2";